<template>
    <div class="animated animated-normal fadeIn">
        <h3 class="form-title border-bottom pb-2 mb-3">Steps</h3>

        <div v-for="(step, index) in steps" :key="step.id">
            <card v-if="step.send_type === 'sms'">
                <card-header class="step__item d-flex">
                    <h5 class="form-title">
                        <small>Step {{ index + 1 }} -</small> SMS
                    </h5>
                    <div class="ml-auto">
                        <div class="form-inline ml-auto">
                            <label>Days of delay:</label>
                            <input type="number" min=0 required
                                class="form-control form-control-sm mx-1 delay__days"
                                :class="{'is-invalid': errors.get(`steps.${[index]}.delay_days`)}"
                                v-model="step.delay_days" />

                            <button class="btn btn-default btn-sm btn-icon"
                                title="Delete"
                                @click="remove(index, step)">
                                <i class="fa fa-fw fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </card-header>
                <card-body>
                    <div class="row">
                        <div class="col-6">
                            <div class="phone-container" >
                                <div class="phone-in">
                                    <div class="box">
                                        <div class="box-message" v-if="step.image || step.content">
                                            <img class="mb-2 rounded img-fluid"
                                                v-if="step.image" :src="step.image_url" />
                                            <div v-html="step.content"></div>
                                        </div>
                                    </div>
                                    <div class="message">
                                        <div class="message-input">
                                            <span>Write a message...</span>
                                        </div>
                                        <div class="message-button"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <upload-image class="form-group"
                                image-label="SMS image"
                                :index="index"
                                v-model="step.image"
                                :url="step.image_url"
                                @preview="preview"
                            />

                            <label>Text (SMS) Message</label>
                            <div class="block__invalid"
                                :class="{'is-invalid': errors.get(`steps.${[index]}.content`)}">
                                <vue-editor
                                    v-model="step.content"
                                    :editor-options="editorSettings"
                                />

                                <p class="invalid-feedback"
                                v-if="errors.has(`steps.${[index]}.content`)">
                                    {{ errors.get(`steps.${[index]}.content`) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </card-body>
            </card>

            <card v-if="step.send_type === 'email'">
                <card-header class="step__item d-flex">
                    <h5 class="form-title">
                        <small>Step {{ index + 1 }} -</small> Email
                    </h5>
                    <div class="ml-auto">
                        <div class="form-inline ml-auto">
                            <label>Days of delay: </label>
                            <input type="number" min=0 class="form-control form-control-sm mx-1 delay__days"
                                :class="{'is-invalid': errors.get(`steps.${[index]}.delay_days`)}"
                                v-model="step.delay_days">

                            <button class="btn btn-default btn-sm btn-icon"
                                title="Delete"
                                @click="remove(index, step)">
                                <i class="fa fa-fw fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </card-header>
                <card-body>
                    <div class="row">
                        <div class="col-12 col-lg-5">
                            <label>Preview</label>
                            <div class="card">
                                <div class="card-body border rounded preview__email">
                                    <img class="mb-2 rounded img-fluid" v-if="step.image"
                                        :src="step.image_url" />
                                    <div v-html="step.content"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7">
                            <upload-image class="form-group"
                                image-label="Email image"
                                :index="index"
                                v-model="step.image"
                                :url="step.image_url"
                                @preview="preview"
                            />

                            <input-text
                                label="From Address"
                                v-model="step.from_address"
                                field="from_address"
                            />

                            <input-text
                                label="From Name"
                                v-model="step.from_name"
                                field="from_name"
                            />

                            <input-text
                                label="Custom Subject"
                                v-model="step.subject"
                                field="subject"
                            />

                            <label>Message</label>
                            <div class="block__invalid"
                                :class="{'is-invalid': errors.get(`steps.${[index]}.content`)}">
                                <vue-editor                                
                                    v-model="step.content"
                                    :editor-options="editorSettings"
                                />

                                <p class="invalid-feedback"
                                v-if="errors.has(`steps.${[index]}.content`)">
                                    {{ errors.get(`steps.${[index]}.content`) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </card-body>
            </card>

            <card v-if="step.send_type === 'campaign'">
                <card-header class="step__item d-flex">
                    <h5 class="form-title">
                        <small>Step {{ index + 1 }} -</small> Campaign
                    </h5>
                    <div class="ml-auto">
                        <div class="form-inline ml-auto">
                            <label>Days of delay: </label>
                            <input type="number" min=0
                                class="form-control form-control-sm mx-1 delay__days"
                                :class="{'is-invalid': errors.get(`steps.${[index]}.delay_days`)}"
                                v-model="step.delay_days">

                            <button class="btn btn-default btn-sm btn-icon"
                                title="Delete"
                                @click="remove(index, step)">
                                <i class="fa fa-fw fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </card-header>
                <card-body>
                    <div class="alert alert-warning" v-if="selectedLocations.error">
                        {{ selectedLocations.message }}
                    </div>

                    <label>Select Campaign</label>
                    <multiselect
                        :class="{'is-invalid': errors.has(`steps.${[index]}.workflow_campaign`)}"
                        v-model="step.workflow_campaign"
                        :options="campaigns"
                        placeholder="Select campaign"
                        label="name"
                        track-by="id"
                    />
                    <p class="invalid-feedback"
                       v-if="errors.has(`steps.${[index]}.workflow_campaign`)">
                        {{ errors.get(`steps.${[index]}.workflow_campaign`) }}
                    </p>
                </card-body>
            </card>
        </div>
    </div>
</template>

<script>
    import { VueEditor, Quill } from 'vue2-editor'

    export default {
        props: {
            selectedLocations: {
                type: Object,
                required: true
            },
            steps: {
                type: Array
            },
            errors: {
                type: Object
            },
            variables: {
                type: Array
            },
            campaigns: {
                type: Array
            }
        },

        components: {
            VueEditor
        },

        data() {
            return {
                customToolbar: [
                    ['bold', 'italic'],
                    ['link'],
                    ['clean']
                ],
                editorSettings: {
                    modules: {
                        toolbar: {
                            container: [
                                ['bold', 'italic'],
                                ['link'],
                                ['clean'],
                                [{ 'variables': this.variables }]
                            ],
                            handlers: {
                                "variables": function (value) {
                                    if (value) {
                                        const cursorPosition = this.quill.getSelection().index;
                                        this.quill.insertText(cursorPosition, value);
                                        this.quill.setSelection(cursorPosition + value.length);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },

        mounted() {
            this.placeholderPickerItems();
        },

        watch: {
            steps() {
                setTimeout(() => this.placeholderPickerItems(), 500);
            }
        },

        methods: {
            placeholderPickerItems() {
                const quillWrapperEditor = Array.prototype.slice.call(document.querySelectorAll('.quillWrapper'));

                quillWrapperEditor.forEach(item => {
                    const placeholderPickerItems = Array.prototype.slice.call(item.querySelectorAll('.ql-variables .ql-picker-item'));

                    placeholderPickerItems.forEach(item => item.textContent = item.dataset.value);

                    if (item.querySelector('.ql-variables .ql-picker-label').innerText === '') {
                        return item.querySelector('.ql-variables .ql-picker-label').innerHTML
                            = 'Insert variable' + item.querySelector('.ql-variables .ql-picker-label').innerHTML;
                    }
                });
            },

            preview(value, index) {
                this.$emit('preview', value, index);
            },

            remove(index, step) {
                this.$confirm().then(() => {
                    this.$emit('remove', index, step);
                    this.$alert({
                        type: 'success',
                        title: 'Success!'
                    });
                });
            },
        }
    }
</script>

<style>
    .ql-toolbar.ql-snow {
        border-top-right-radius: .25rem;
        border-top-left-radius: .25rem;
    }

    .ql-container.ql-snow {
        border-bottom-right-radius: .25rem;
        border-bottom-left-radius: .25rem;
    }

    .ql-toolbar.ql-snow .ql-variables .ql-picker-label {
        padding-right: 18px;
    }
</style>

<style lang="scss" scoped>
    .step__item {
        background-color: #f1f1f1;
    }
    .delay__days {
        max-width: 5rem;
    }

    .phone-container {
        position: relative;
        width: 300px;
        height: 619px;
        margin: auto;
        background: url('/img/phone.svg') center/contain no-repeat;
        .phone-in {
            position: absolute;
            top: 94px;
            left: 29px;
            background-color: white;
            width: 243px;
            height: 432px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding: 1em;

            .box {
                flex: 1;
                display: flex;
                justify-content: flex-start;
                align-items: flex-end;
                margin: 0.5em 0 0.5em 0.5em;

                .box-message {
                    position: relative;
                    bottom: 2em;
                    display: inline-block;
                    max-width: 250px;
                    max-height: 350px;
                    font-size: 0.8rem;
                    width: auto;
                    padding: 0.5em;
                    background-color: #007bff;
                    color: white;
                    border-radius: 10px;
                    word-break: break-all;

                    opacity: 0;
                    animation: boxappear 0.4s 1s forwards
                    cubic-bezier(0.165, 0.84, 0.44, 1);
                    &::before {
                        content: "";
                        position: absolute;
                        left: -8px;
                        width: 0;
                        height: 0;
                        border-top: 10px solid transparent;
                        border-bottom: 10px solid transparent;
                        border-right: 10px solid #007bff;
                    }
                }
            }

            .message {
                display: flex;
                .message-input {
                    font-size: 0.8em;
                    padding: 0.5em 1em;
                    border-radius: 20px;
                    background-color: #f2f2f2;
                    color: #888;
                    margin-right: 1em;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex: 0.8;
                    opacity: 0;
                    animation: message 1s forwards
                    cubic-bezier(0.165, 0.84, 0.44, 1);
                }
                .message-button {
                    background: #007bff url('/img/paper-plane.svg') 45%/45%
                    no-repeat;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    animation: button 1s 2 cubic-bezier(0.165, 0.84, 0.44, 1);
                }
            }
        }
    }

    .preview__email {
        min-height: 300px;
    }

    @keyframes boxappear {
        from { transform: translateY(10%); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
    }
    @keyframes message {
        from { flex: 0.8; opacity: 0; }
        to { flex: 1; opacity: 1; }
    }

    @keyframes button {
        from { transform: scale(0.8); }
        50% { transform: scale(1.1); }
        to { transform: scale(1); }
    }
</style>
